(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cocomii-performance-global"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function applyWalletLayout(wrapper) {
      var selector = 'shop-pay-wallet-button, shopify-apple-pay-button, shopify-paypal-button, shopify-google-pay-button';
      var hosts = Array.prototype.filter.call(wrapper.querySelectorAll(selector), function (host) {
        return host.offsetParent !== null;
      });
      if (!hosts.length) return;

      wrapper.style.setProperty('display', 'block', 'important');
      wrapper.style.setProperty('padding', '0', 'important');
      wrapper.style.setProperty('margin', '0', 'important');
      wrapper.style.setProperty('gap', '0', 'important');

      hosts.forEach(function (host) {
        var shopPay = host.tagName.toLowerCase() === 'shop-pay-wallet-button';
        host.style.setProperty('display', 'block', 'important');
        host.style.setProperty('margin', '0', 'important');
        host.style.setProperty('padding', '0', 'important');
        host.style.setProperty('overflow', shopPay ? 'visible' : 'hidden', 'important');

        if (shopPay) {
          host.style.setProperty('min-height', '48px', 'important');
          host.style.removeProperty('line-height');
          host.style.removeProperty('font-size');
        } else {
          host.style.setProperty('line-height', '0', 'important');
          host.style.setProperty('font-size', '0', 'important');
        }
      });

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var previousBottom = null;
          hosts.forEach(function (host) {
            host.style.setProperty('margin-top', '0', 'important');
            var rect = host.getBoundingClientRect();
            if (previousBottom !== null) {
              var delta = 3 - Math.round(rect.top - previousBottom);
              if (delta) host.style.setProperty('margin-top', delta + 'px', 'important');
            }
            previousBottom = host.getBoundingClientRect().bottom;
          });

          var shopPay = hosts.find(function (host) {
            return host.tagName.toLowerCase() === 'shop-pay-wallet-button';
          });
          if (shopPay) {
            var height = Math.max(Math.round(shopPay.getBoundingClientRect().height) || 0, 48);
            shopPay.style.setProperty('height', height + 'px', 'important');
            shopPay.style.setProperty('min-height', height + 'px', 'important');
          }
        });
      });
    }

    function watchWalletWrapper(wrapper) {
      if (wrapper.dataset.cocomiiWalletWatch === 'true') return;
      wrapper.dataset.cocomiiWalletWatch = 'true';
      var queued = false;
      var schedule = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          applyWalletLayout(wrapper);
        });
      };
      new MutationObserver(schedule).observe(wrapper, { childList: true, subtree: true });
      schedule();
    }

    function initWallets() {
      document.querySelectorAll('.additional-checkout-buttons--vertical, .additional-checkout-buttons').forEach(watchWalletWrapper);
    }

    initWallets();
    document.addEventListener('cart:updated', initWallets);
    document.addEventListener('ajaxProduct:added', initWallets);
    document.addEventListener('shopify:section:load', initWallets);

    /* Hover-intent prefetch of internal links (replaces tiny-img-link-preloader) */
    (function () {
      if (navigator.connection && (navigator.connection.saveData || /(^|-)2g$/.test(navigator.connection.effectiveType || ''))) return;
      var prefetched = Object.create(null);
      var hoverTimer = null;
      var supportsSpeculation = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');

      function eligible(anchor) {
        if (!anchor || !anchor.href) return null;
        if (anchor.origin !== location.origin) return null;
        if (anchor.hasAttribute('download') || anchor.target === '_blank') return null;
        var path = anchor.pathname;
        if (path === location.pathname) return null;
        if (/^\/(cart|checkout|account|admin|challenge)/.test(path)) return null;
        if (/\.(jpg|jpeg|png|gif|webp|svg|pdf|zip|mp4|webm)$/i.test(path)) return null;
        var url = anchor.href.split('#')[0];
        if (prefetched[url]) return null;
        return url;
      }

      function prefetch(url) {
        prefetched[url] = true;
        if (supportsSpeculation) {
          var script = document.createElement('script');
          script.type = 'speculationrules';
          script.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [url] }] });
          document.head.appendChild(script);
        } else {
          var link = document.createElement('link');
          link.rel = 'prefetch';
          link.href = url;
          link.as = 'document';
          document.head.appendChild(link);
        }
      }

      document.addEventListener('mouseover', function (event) {
        var anchor = event.target.closest && event.target.closest('a[href]');
        var url = eligible(anchor);
        if (!url) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { prefetch(url); }, 65);
      }, { passive: true });

      document.addEventListener('mouseout', function () {
        clearTimeout(hoverTimer);
      }, { passive: true });

      document.addEventListener('touchstart', function (event) {
        var anchor = event.target.closest && event.target.closest('a[href]');
        var url = eligible(anchor);
        if (url) prefetch(url);
      }, { passive: true });
    })();
  })();

  /* Keep the space reserved for the fixed announcement bar equal to the bar's
     actual height. theme.css hardcodes 38px, which is wrong by whatever the bar
     really measures on a given device, and the difference shows as a white strip
     under it. Paired with the --cocomii-announcement-h rule in the stylesheet. */
  (function () {
    var root = document.documentElement;

    function sync() {
      var bar = document.querySelector('.announcement-bar');
      if (!bar) return;
      var height = bar.getBoundingClientRect().height;
      if (height > 0) root.style.setProperty('--cocomii-announcement-h', height + 'px');
    }

    sync();
    document.addEventListener('DOMContentLoaded', sync);
    window.addEventListener('load', sync);
    window.addEventListener('orientationchange', function () { setTimeout(sync, 150); });
    // Web fonts land after first paint and change the bar's line box.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    // theme.liquid relocates the bar into the sticky wrapper, and the text is a
    // rotating slideshow, so watch the element rather than trusting one measure.
    if (window.ResizeObserver) {
      var observed = document.querySelector('.announcement-bar');
      if (observed) new ResizeObserver(sync).observe(observed);
    }
  })();

  /* Pin the mobile hero height to a plain pixel value.

     The heroes are sized in viewport units, so on a phone they track the URL
     bar: growing as it collapses on the way down, shrinking as it returns on
     the way up. svh is specified to be immune to exactly that, and on the
     owner's Chrome it was not, so this stops relying on viewport-unit semantics
     altogether and hands the stylesheet a fixed px value it cannot reinterpret.

     Measured once at load and then only when the WIDTH changes. A URL-bar
     collapse changes the height alone and is ignored, which is the whole point;
     rotation changes the width and is honoured. Above 768px the variable is
     removed so desktop falls back to the stylesheet's own value. */
  (function () {
    var root = document.documentElement;
    var lastWidth = window.innerWidth;

    function setHeroHeight() {
      if (window.innerWidth > 768) {
        root.style.removeProperty('--cocomii-hero-h');
        return;
      }
      root.style.setProperty('--cocomii-hero-h', Math.round(window.innerHeight * 0.9) + 'px');
    }

    setHeroHeight();
    document.addEventListener('DOMContentLoaded', setHeroHeight);

    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      setHeroHeight();
    });

    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        lastWidth = window.innerWidth;
        setHeroHeight();
      }, 200);
    });
  })();

  /* Put the hero poster behind the video so a loop wrap cannot flash the
     section's near-black background. See the .hero__media rule in the
     stylesheet for the sizing half of this. */
  (function () {
    function paintPoster() {
      var medias = document.querySelectorAll('.video-parent-section .hero__media');
      for (var i = 0; i < medias.length; i++) {
        var media = medias[i];
        if (media.style.backgroundImage) continue;
        var video = media.querySelector('video[poster]');
        if (!video) continue;
        // Read the attribute, not the property: the property resolves to an
        // absolute URL, which is fine, but an empty attribute yields the page
        // URL and would paint the document behind the video.
        var poster = video.getAttribute('poster');
        if (!poster) continue;
        media.style.backgroundImage = 'url("' + video.poster + '")';
      }
    }

    paintPoster();
    document.addEventListener('DOMContentLoaded', paintPoster);
    window.addEventListener('load', paintPoster);
  })();
/* Hover to open the CASES and DESIGNS megamenus.

     The theme binds this itself, but only as the LAST call in a single chained
     statement inside HeaderSection.init():

       this.initDrawers(), this.initDisclosures(), theme.headerNav.init(),
       theme.announcementBar.init(), this.hoverMenu()

     Because it is one comma expression, anything that throws earlier silently
     skips hoverMenu, and the menus fall back to native click-to-toggle. That is
     the reported symptom exactly, and it depends on which optional pieces load,
     which is why it appeared in one browser and not another.

     This binds hover independently so it cannot be skipped. It is idempotent:
     each details element is marked, so it never double-binds alongside the
     theme's own handler, and both handlers do the same thing anyway. Only the
     open/close behaviour is re-bound; the theme's click-to-navigate is left
     alone so nothing is duplicated there. */
  (function () {
    function bindHover() {
      var menus = document.querySelectorAll('[data-section-type="header"] details[data-hover="true"]');
      for (var i = 0; i < menus.length; i++) {
        var d = menus[i];
        if (d.dataset.cocomiiHoverBound === 'true') continue;
        d.dataset.cocomiiHoverBound = 'true';
        (function (detail) {
          detail.addEventListener('mouseover', function () {
            if (!detail.hasAttribute('open')) {
              detail.setAttribute('open', '');
              detail.setAttribute('aria-expanded', 'true');
            }
          });
          detail.addEventListener('mouseleave', function () {
            if (detail.hasAttribute('open')) {
              detail.removeAttribute('open');
              detail.setAttribute('aria-expanded', 'false');
            }
          });
        })(d);
      }
    }

    bindHover();
    document.addEventListener('DOMContentLoaded', bindHover);
    window.addEventListener('load', bindHover);
    // The header re-renders in the theme editor and on some app injections.
    document.addEventListener('shopify:section:load', bindHover);
  })();
/* Notify Me on a sold out card.

     Submits through the real Liquid contact form in cocomii-notify-form.liquid.

     It used to fetch-POST /contact directly. That always failed: the store has
     Shopify's invisible hCaptcha on contact forms, which refuses a tokenless
     post with 400, and this handler treated any settled promise as success. So
     it showed "YOU ARE ON THE LIST" while discarding the address. Nothing was
     ever captured. Never report success the server did not confirm.

     It now adds the address to the subscribed list (form_type=customer) and
     tags it notify:<variantId>, rather than emailing the store. There is
     deliberately no per-variant alert queue: restocks are announced to the list.
     The tag keeps the demand data, so the list can be segmented by what people
     actually wanted and a real per-variant alert stays buildable later. */
  (function () {
    'use strict';

    function submitRequest(form, data) {
      var send = form.querySelector('button');
      var email = form.querySelector('input').value;
      // Hand off to the real Liquid form. It performs a native submit, so the
      // page navigates and the outcome is reported on the way back from the
      // server rather than guessed at here.
      if (typeof window.cocomiiNotifySubmit !== 'function') {
        form.innerHTML = '<span class="cocomii-notify__done">Please try again</span>';
        return;
      }
      send.textContent = 'SENDING';
      send.disabled = true;
      if (!window.cocomiiNotifySubmit(email, data)) {
        send.textContent = 'NOTIFY ME';
        send.disabled = false;
      }
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest('.cocomii-notify');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var data = {
        title: btn.getAttribute('data-title') || '',
        colour: btn.getAttribute('data-colour') || '',
        model: btn.getAttribute('data-model') || '',
        variant: btn.getAttribute('data-variant') || ''
      };
      var form = document.createElement('form');
      form.className = 'cocomii-notify__form';
      form.setAttribute('novalidate', 'novalidate');
      // The aria-label used to read "Email me when this is back in stock".
      // Nothing sends a per-product alert, so that was a promise we do not keep.
      // The field joins the COCOMII list, where restocks are announced, and the
      // small print says exactly that before they submit.
      form.innerHTML =
        '<input type="email" required class="cocomii-notify__input" placeholder="Email address" aria-label="Email address to join the COCOMII list">' +
        '<button type="submit" class="quick-product__btn">NOTIFY ME</button>' +
        '<span class="cocomii-notify__fine">Joins the COCOMII list, where restocks are announced. Unsubscribe anytime.</span>';
      btn.parentNode.replaceChild(form, btn);
      form.addEventListener('click', function (ev) { ev.stopPropagation(); });
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var input = form.querySelector('input');
        if (!input.value || input.value.indexOf('@') < 0) { input.focus(); return; }
        submitRequest(form, data);
      });
      form.querySelector('input').focus();
      // Focusing the visible input does not bind the hidden Liquid form, so ask
      // for it explicitly and give hCaptcha time to attach before they submit.
      if (typeof window.cocomiiNotifyPrepare === 'function') { window.cocomiiNotifyPrepare(); }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-images"] && !Shopify.designMode) return;
  try {
    (function () {
    function hydrate(video) {
      if (video.dataset.cocomiiHydrated === 'true') return;
      video.dataset.cocomiiHydrated = 'true';
      video.querySelectorAll('source[data-src]').forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saveData = navigator.connection && navigator.connection.saveData;
      if (reducedMotion || saveData) {
        video.controls = true;
        return;
      }

      var play = video.play();
      if (play !== undefined) {
        play.catch(function () {
          video.controls = true;
        });
      }
    }

    function init(root) {
      var videos = root.querySelectorAll('[data-cocomii-lazy-video]:not([data-cocomii-observed])');
      videos.forEach(function (video) {
        video.dataset.cocomiiObserved = 'true';
        if (!('IntersectionObserver' in window)) {
          hydrate(video);
          return;
        }
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            hydrate(video);
          });
        }, { rootMargin: '300px 0px' });
        observer.observe(video);
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
      syncColorVideo();
    });

    /* ---- colourway video follows the colour picker -----------------------
       The block above is rendered server side for one variant. Without this,
       changing colour on the PDP left the previous colourway's video playing.
       We read the checked colour radio (authoritative, whatever caused the
       change) and reveal the slot whose data-cocomii-video-color matches. */

    function currentColor() {
      var input = document.querySelector('fieldset.variant-input-wrap[data-handle="color"] input:checked');
      if (!input) return '';
      return (input.value || input.getAttribute('data-color-name') || '').trim().toLowerCase();
    }

    function resume(video) {
      if (!video) return;
      if (video.dataset.cocomiiHydrated !== 'true') { hydrate(video); return; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var play = video.play();
      if (play !== undefined) {
        play.then(function () {
          // playback took, so drop the fallback controls bar if a previous
          // attempt had been refused (backgrounded tab, for instance)
          video.controls = false;
        }).catch(function () {
          video.controls = true;
        });
      }
    }

    function syncColorVideo() {
      var slots = document.querySelectorAll('[data-cocomii-video-color]');
      if (!slots.length) return;
      var want = currentColor();
      var shown = null;
      for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        var mine = (slot.getAttribute('data-cocomii-video-color') || '').trim().toLowerCase();
        if (!shown && want && mine === want) {
          shown = slot;
        } else {
          if (!slot.hidden) {
            slot.hidden = true;
            var paused = slot.querySelector('video');
            if (paused && !paused.paused) paused.pause();
          }
        }
      }
      if (shown && shown.hidden) shown.hidden = false;
      if (shown) resume(shown.querySelector('video'));
    }

    document.addEventListener('change', function (event) {
      var t = event.target;
      if (!t || t.type !== 'radio') return;
      if (!t.closest || !t.closest('fieldset.variant-input-wrap[data-handle="color"]')) return;
      syncColorVideo();
    });

    /* Belt and braces: the theme fires these when the variant changes for any
       other reason (deep link, model switch forcing a colour, back button). */
    document.addEventListener('variantChange', syncColorVideo);
    document.addEventListener('variant:change', syncColorVideo);

    /* Browsers refuse autoplay while the tab is backgrounded. Retry the active
       colourway once the shopper comes back to it. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') syncColorVideo();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
